module.exports = __webpack_public_path__ + "img/icon-star5-active.5b0a9dec.png";